import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import CoreMap from '@bd/bdui-coremap';
import withData from '@bd/bdcore-data';
import HomeCard from '../../components/HomeCard';
import HomeMapCard from '../../components/HomeMapCard';
import { colors } from '../../styles';

const styles = css``;

const homeMap = css`
  position: relative;
  height: calc(75vh - 115px);
  width: 100%;
  z-index: 0;

  @media (min-width: 992px) {
    width: auto;
    flex-grow: 1;
  }

  background-color: ${colors.color3};
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup-content-wrapper {
    .HomeCard_wrapper {
      width: 100% !important;
    }
    .HomeCard_inner {
      flex-direction: column !important;
    }
    .HomeCard_mapButton {
      display: none !important;
    }
    .HomeCard_detailButton {
      width: 100% !important;
    }
    .HomeCard_buttonWrapper {
      margin: 0 !important;
    }
    .HomeCard_priceValue {
      padding: 10px 8px !important;
    }
  }
`;

function HomesResults({ homes, sort, showMap }) {
  return (
    <div className={styles}>
      {
        showMap &&
        <CoreMap
          animate
          useFlyTo
          boundsOptions={{ animate: true, duration: 0.5 }}
          pin={{
            iconUrl: '/images/icon-map-pin-woodbridge.svg',
            iconSize: [32, 46],
            iconAnchor: [16, 46],
            popupAnchor: [0, -41],
          }}
          className={homeMap}
          markers={homes}
          popup={({ marker: home }) => (
            <HomeMapCard home={home} />
          )}
        />
      }
      {
        !showMap &&
        <div className="container">
          <div className="row py-5 justify-content-center">
            {
              orderBy(homes, sort.field, get(sort, 'dir', 'asc')).map(home => (
                <div key={home._id} className="col-md-6 col-xl-4">
                  <HomeCard home={home} />
                </div>
              ))
            }
          </div>
        </div>
      }
    </div>
  );
}

HomesResults.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object.isRequired,
  showMap: PropTypes.bool.isRequired,
};

export default withData(
  {
    homes: true,
  },
)(HomesResults);



// WEBPACK FOOTER //
// ./src/pages/Homes/HomesResults.js